export default {
    getList: {
        getTable: async function (params) {
            let option = {
                url: '/api/v1/superviser/partners',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: {}
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    },
    do: {
        resetPartner: async function (params) {
            let option = {
                url: '/api/v1/superviser/partner/' + params.id,
                type: 'patch',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        creatPartner: async function (params) {
            let option = {
                url: '/api/v1/superviser/partner',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        editorPartner: async function (params) {
            let option = {
                url: '/api/v1/superviser/partner/' + params.id,
                type: 'put',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        freezePartner: async function (params) {
            let option = {
                url: '/api/v1/superviser/ban',
                type: 'put',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminSiteManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}